/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Icon } from "antd-mobile";

const StyledContainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: ${props => (props.transparentMode ? "unset" : "1px solid lightgrey")};
  border-top: unset;
  background: ${props => (props.transparentMode ? "#0000001A" : "white")};
  color: ${props => (props.transparentMode ? "white" : "black")};
  height: 3.6em;
  top: 0;
  z-index: 10;
  box-shadow: ${props =>
    props.transparentMode ? "unset" : "0 4px 6px -5px grey"};
`;

const StyledCenterContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 7.8;
`;

const StyledLeftContainer = styled.div`
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1.1;
`;

const StyledRightContainer = styled.div`
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1.1;
`;

class NavBar extends Component {
  render() {
    const {
      className,
      leftIcon,
      middleTitle,
      rightIcon,
      onLeftIconClick,
      onRightIconClick,
      history,
      transparentMode,
      inputRef
    } = this.props;

    return (
      <StyledContainer
        transparentMode={transparentMode}
        ref={inputRef}
        className={className}
      >
        <StyledLeftContainer
          onClick={() => {
            if (onLeftIconClick) {
              onLeftIconClick();
            } else if (!leftIcon && !onLeftIconClick) {
              history.goBack();
            }
          }}
        >
          {leftIcon ? leftIcon : <Icon type="left" size="md" />}
        </StyledLeftContainer>
        <StyledCenterContainer>{middleTitle}</StyledCenterContainer>
        <StyledRightContainer
          onClick={() => onRightIconClick && onRightIconClick()}
        >
          {rightIcon ? rightIcon : null}
        </StyledRightContainer>
      </StyledContainer>
    );
  }
}

NavBar.propTypes = {
  className: PropTypes.string,
  leftIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  rightIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  middleTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  onLeftIconClick: PropTypes.func,
  onRightIconClick: PropTypes.func,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  transparentMode: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  inputRef: PropTypes.object
};

NavBar.propTypes = {
  transparentMode: false
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js